import { useState } from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import PublicLayout from "@/components/PublicLayout";
import { CaretDown, Question, ArrowRight } from "@phosphor-icons/react";

// Placeholder FAQ — edit the questions/answers below with your own content.
const FAQS = [
  { q: "What is PhotoPulse.pro?", a: "PhotoPulse is a shared media library for the SocialPulse network. It turns everyday photo libraries into a searchable, AI-organised collection of nature, landscapes, sunsets and cityscapes that people can explore and reuse. (Edit this answer.)" },
  { q: "Is it free to browse?", a: "Yes — anyone can explore the public gallery, search by place or category, and open a photo's page without creating an account. (Edit this answer.)" },
  { q: "How do you organise the photos?", a: "Each photo is analysed by AI for its subject and scene, reverse-geocoded to a place, and grouped into collections automatically — no manual tagging required. (Edit this answer.)" },
  { q: "Can I contribute my own photos?", a: "Absolutely. Create a free account, upload a photo (or a whole archive), and choose how it can be reused across the network. (Edit this answer.)" },
  { q: "Who can reuse my photos?", a: "You decide per photo — keep it private, share it across specific SocialPulse sites, or allow public reuse with attribution. Only photos you mark as public appear in the public gallery. (Edit this answer.)" },
  { q: "Do you show photos of people?", a: "The public gallery focuses on nature, places and cityscapes. Personal, people-centric photos are kept out of the public showcase. (Edit this answer.)" },
];

function Item({ q, a, open, onToggle, idx }) {
  return (
    <div className="border-b border-border" data-testid={`faq-item-${idx}`}>
      <button onClick={onToggle} className="flex w-full items-center justify-between gap-4 py-5 text-left">
        <span className="font-display text-base font-bold text-zinc-900">{q}</span>
        <CaretDown size={18} weight="bold" className={`shrink-0 text-[#F27A54] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="pb-5 text-sm leading-relaxed text-zinc-600">{a}</p>}
    </div>
  );
}

export default function Faq() {
  useSeo({ title: "FAQ — PhotoPulse.pro", description: "Frequently asked questions about PhotoPulse.pro — the SocialPulse network's public photo library." });
  const [open, setOpen] = useState(0);
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-5 py-16">
        <div className="text-center">
          <span className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-[#F27A54]/10 text-[#F27A54]"><Question size={26} weight="fill" /></span>
          <h1 className="mt-4 font-display text-4xl font-black tracking-tight">Frequently asked questions</h1>
          <p className="mt-2 text-sm text-muted-foreground">Everything you might want to know. (Placeholder content — edit freely.)</p>
        </div>
        <div className="mt-10">
          {FAQS.map((f, i) => (
            <Item key={i} idx={i} q={f.q} a={f.a} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
        <div className="mt-12 rounded-xl bg-[#F27A54] p-6 text-center text-white">
          <p className="font-display text-lg font-bold">Still curious?</p>
          <p className="mt-1 text-sm text-white/80">Explore the gallery or start contributing your own photos.</p>
          <div className="mt-4 flex flex-wrap justify-center gap-3">
            <Link to="/explore" className="rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#F27A54] hover:bg-white/90">Explore gallery</Link>
            <Link to="/login" className="flex items-center gap-1.5 rounded-full bg-white/15 px-5 py-2.5 text-sm font-bold backdrop-blur hover:bg-white/25">Contribute <ArrowRight size={14} weight="bold" /></Link>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
